import { Oval } from "react-loader-spinner";

function BlueButton({ onClicked, title, isLoading }) {
  return (
    <div
      onClick={() => !isLoading && onClicked()}
      className="cursor-pointer bg-blueColor rounded-[6px] flex items-center justify-center font-OpenSansRegular font-[600] text-[10px] text-white"
      style={{
        width: isLoading ? `${title.length * 10}px` : "auto",
        padding: "0 10px",
        height: "30px",
        minWidth: `${title.length * 10}px`,
      }}
    >
      {isLoading ? (
        <Oval
          visible={true}
          height="16"
          width="16"
          color="#FFFFFF"
          strokeWidth={8}
          secondaryColor="#FFEEFF"
          ariaLabel="oval-loading"
        />
      ) : (
        <span>{title}</span>
      )}
    </div>
  );
}

export default BlueButton;
